import { ComponentProps, ReactElement } from 'react';
import { formatNumber, getClasses } from '@/utils';

import Table from '@/common/Table';

export type InvoicePdfTotalRowProps = ComponentProps<typeof Table.Row> & {
  name: string;
  total: number;
  isGrand?: boolean;
  isTotalSaving?: boolean;
};

const InvoicePdfTotalRow = ({ name, total, isGrand, isTotalSaving, ...props }: InvoicePdfTotalRowProps): ReactElement => (
  <Table.Row
    {...props}
    className={getClasses(
      'InvoicePdf-Totals-Item',
      isGrand ? 'InvoicePdf-Totals-Item-Grand' : undefined,
      isTotalSaving ? 'InvoicePdf-Totals-Item-Saving' : undefined
    )}
  >
    <Table.Cell />
    <Table.Cell className="LABEL">{name}:</Table.Cell>
    <Table.Cell className="TOTAL" data-prefix="USD ">
      {formatNumber.currency(total)}
    </Table.Cell>
  </Table.Row>
);

export default InvoicePdfTotalRow;
